import React from 'react';
import moment from 'moment';
import Circular from './circular';
import Bar from './bar';
import Evolution from './evolutionGraph';
import AvatarImg from '../../../../public/images/empresa.png';
import Ranking from './ranking';

const position = obj => {
  if (obj.value || obj.value > 0) {
    let total = 138 * obj.value;
    total /= obj.total;
    total += 65;
    return total;
  }
  return 65;
};

const validateDate = (filter, date) => {
  let dateValue;
  if (filter) {
    dateValue = filter;
  } else if (date) {
    dateValue = date.substring(0, 10);
  } else {
    dateValue = new Date();
  }
  return moment(dateValue).format('DD-MM-YYYY');
};

const colorSeverityItem = severety => {
  // condition to define the color as defined in the api
  if (severety == null) {
    return 'gris';
  } else if (severety.toUpperCase() === 'HIGHRISK' || severety.toUpperCase() === 'WORSE') {
    return 'red';
  } else if (severety.toUpperCase() === 'LOWRISK' || severety.toUpperCase() === 'BETTER') {
    return 'green';
  }
  return 'yellow';
};

const Main = props => {
  return (
    <section className="container-main-principal flex">
      <section className="module-box-circular">
        <div className="avatar">
          <img src={AvatarImg} alt="avatar" />
        </div>
        <Circular
          inRisk={props.datos.inRisk}
          currentGoalValue={props.datos.currentGoalValue}
          goalAchieved={props.datos.goalAchieved}
          nfa={props.nfa}
          language={props.language}
        />
      </section>
      <section className="evolution">
        <Evolution
          tooltip={props.tooltip}
          graphColorRange={props.nfa.graphRange}
          data={props.datos.evolution}
        />
        {props.datos.evolution.length > 0 && (
          <span
            className={colorSeverityItem(
              props.datos.evolution[props.datos.evolution.length - 1].risk
            )}
            style={{
              bottom: position({
                total: 100,
                value: props.datos.evolution[props.datos.evolution.length - 1].averageScoreDay
              })
            }}
          >
            {props.datos.evolution[props.datos.evolution.length - 1].averageScoreDay}%
          </span>
        )}
      </section>
      <Ranking
        link={props.link}
        handleSort={props.handleSort}
        handleScroll={props.handleScroll}
        language={props.language}
        main={props.main}
        ranking={props.ranking}
      />
      <section className="container-desviaciones">
        <section className="container-box-desviaciones">
          <h3>{props.language.detail_fatigue.nfa.Deviations}</h3>
          <h4>{props.language.detail_fatigue.nfa.distribution}</h4>
          <Bar
            distribution={props.BPM.distribution}
            title={props.title}
            language={props.language}
          />
          <ul>
            {props.BPM.distribution.map((item, i) => (
              <li key={i} className={`li-${item.risk.toUpperCase()}`}>
                {' '}
                {props.language.summary.graphTooltip[item.risk.toUpperCase()]}
              </li>
            ))}
          </ul>

          <p>
            {props.language.detail_fatigue.nfa.deviationQuantity}: {props.BPM.tasks}
          </p>
          <p>
            {props.language.detail_fatigue.nfa.managmentQuantity}
            {validateDate(props.filters.date.fechaEndFinal, props.date.response.maxDate)}:{' '}
            {props.BPM.currentTasks}
          </p>
          <p>
            {props.language.detail_fatigue.nfa.managmentQuantityTime}: {props.BPM.openTask.value} (
            {props.BPM.openTask.percentage}
            %)
          </p>
        </section>
        <button data-close="ok" onClick={props.handleModal}>
          Ver detalle
        </button>
      </section>
    </section>
  );
};
export default Main;



// WEBPACK FOOTER //
// ./source/client/components/detail_nfa/main.jsx